/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'

import type {
  AccountOauthGtowizardCreate400,
  AccountOauthGtowizardCreate500,
  CustomTokenObtain,
  GTOWizardOAuthCallback,
  GTOWizardOAuthResponse,
  TokenPair,
  TokenRefresh,
} from '../models'

import accountOauthGtowizardCreateMutator from '../../client'
import tokenCreateMutator from '../../client'
import tokenRefreshCreateMutator from '../../client'

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{ [Q in P]: T[P] }, { -readonly [Q in P]: T[P] }, P>
}[keyof T]

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void
  ? I
  : never
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never

type Writable<T> = Pick<T, WritableKeys<T>>
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object ? NonReadonly<NonNullable<T[P]>> : T[P]
    }
  : DistributeReadOnlyOverUnions<T>

/**
 * Handles OAuth callback from GTO Wizard. Exchanges authorization code for access tokens, creates new user account or logs in existing user, and returns JWT tokens for authentication.
 * @summary GTO Wizard OAuth Callback
 */
export const accountOauthGtowizardCreate = (
  gTOWizardOAuthCallback: GTOWizardOAuthCallback,
  signal?: AbortSignal,
) => {
  return accountOauthGtowizardCreateMutator<GTOWizardOAuthResponse>({
    url: `/api/v1/account/oauth/gtowizard/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: gTOWizardOAuthCallback,
    signal,
  })
}

export const getAccountOauthGtowizardCreateMutationOptions = <
  TError = AccountOauthGtowizardCreate400 | AccountOauthGtowizardCreate500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountOauthGtowizardCreate>>,
    TError,
    { data: GTOWizardOAuthCallback },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountOauthGtowizardCreate>>,
  TError,
  { data: GTOWizardOAuthCallback },
  TContext
> => {
  const mutationKey = ['accountOauthGtowizardCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountOauthGtowizardCreate>>,
    { data: GTOWizardOAuthCallback }
  > = (props) => {
    const { data } = props ?? {}

    return accountOauthGtowizardCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AccountOauthGtowizardCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountOauthGtowizardCreate>>
>
export type AccountOauthGtowizardCreateMutationBody = GTOWizardOAuthCallback
export type AccountOauthGtowizardCreateMutationError =
  | AccountOauthGtowizardCreate400
  | AccountOauthGtowizardCreate500

/**
 * @summary GTO Wizard OAuth Callback
 */
export const useAccountOauthGtowizardCreate = <
  TError = AccountOauthGtowizardCreate400 | AccountOauthGtowizardCreate500,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountOauthGtowizardCreate>>,
    TError,
    { data: GTOWizardOAuthCallback },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof accountOauthGtowizardCreate>>,
  TError,
  { data: GTOWizardOAuthCallback },
  TContext
> => {
  const mutationOptions = getAccountOauthGtowizardCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Takes a set of user credentials (email and password) and returns an access and refresh JSON web token pair.
 * @summary Obtain JWT key pair
 */
export const tokenCreate = (customTokenObtain: CustomTokenObtain, signal?: AbortSignal) => {
  return tokenCreateMutator<TokenPair>({
    url: `/api/v1/token/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: customTokenObtain,
    signal,
  })
}

export const getTokenCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tokenCreate>>,
    TError,
    { data: CustomTokenObtain },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof tokenCreate>>,
  TError,
  { data: CustomTokenObtain },
  TContext
> => {
  const mutationKey = ['tokenCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tokenCreate>>,
    { data: CustomTokenObtain }
  > = (props) => {
    const { data } = props ?? {}

    return tokenCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type TokenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tokenCreate>>>
export type TokenCreateMutationBody = CustomTokenObtain
export type TokenCreateMutationError = unknown

/**
 * @summary Obtain JWT key pair
 */
export const useTokenCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tokenCreate>>,
    TError,
    { data: CustomTokenObtain },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof tokenCreate>>,
  TError,
  { data: CustomTokenObtain },
  TContext
> => {
  const mutationOptions = getTokenCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Takes a refresh token and returns a new access token if the refresh token is valid.
 * @summary Refresh JWT access token
 */
export const tokenRefreshCreate = (
  tokenRefresh: NonReadonly<TokenRefresh>,
  signal?: AbortSignal,
) => {
  return tokenRefreshCreateMutator<TokenRefresh>({
    url: `/api/v1/token/refresh/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: tokenRefresh,
    signal,
  })
}

export const getTokenRefreshCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tokenRefreshCreate>>,
    TError,
    { data: NonReadonly<TokenRefresh> },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof tokenRefreshCreate>>,
  TError,
  { data: NonReadonly<TokenRefresh> },
  TContext
> => {
  const mutationKey = ['tokenRefreshCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tokenRefreshCreate>>,
    { data: NonReadonly<TokenRefresh> }
  > = (props) => {
    const { data } = props ?? {}

    return tokenRefreshCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type TokenRefreshCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tokenRefreshCreate>>
>
export type TokenRefreshCreateMutationBody = NonReadonly<TokenRefresh>
export type TokenRefreshCreateMutationError = unknown

/**
 * @summary Refresh JWT access token
 */
export const useTokenRefreshCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tokenRefreshCreate>>,
    TError,
    { data: NonReadonly<TokenRefresh> },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof tokenRefreshCreate>>,
  TError,
  { data: NonReadonly<TokenRefresh> },
  TContext
> => {
  const mutationOptions = getTokenRefreshCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
